import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this._checkScroll()
        window.addEventListener("scroll", () => {
            this._checkScroll()
        })
    }

    scrollUp() {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        })
    }

    _checkScroll() {
        if (window.scrollY > 500) {
            this.element.classList.remove("translate-x-18")
        } else {
            this.element.classList.add("translate-x-18")
        }
    }
}
